import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-rebate',
  standalone: false,
  
  templateUrl: './sales-rebate.component.html',
  styles: ``
})
export class SalesRebateComponent {

}
